import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { KnBrCommonService } from 'src/services/kn-br-common.service';
// TODO:Spartacus - UserActions - Following actions 'ForgotPasswordEmailRequestAction', 'ResetPasswordAction', 'EmailActions', 'UpdatePasswordAction', 'UserDetailsAction' were removed. Logic was moved to '@spartacus/user'.
import { OrderActions } from '@spartacus/order/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class KnBrSpinnerEffects {
  // @Effect({ dispatch: false })
  orderDetailNotify$: Observable<any> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrderActions.LOAD_ORDER_DETAILS),
        map((action: any) => action.payload),
        map(() => this.knBrCommonServive.setSpinner(true))
      ),
    { dispatch: false }
  );

  // @Effect({ dispatch: false })
  orderDetailSucessNotify$: Observable<any> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrderActions.LOAD_ORDER_DETAILS_SUCCESS),
        map((action: any) => action.payload),
        map(() => this.knBrCommonServive.setSpinner(false))
      ),
    { dispatch: false }
  );

  // @Effect({ dispatch: false })
  orderDetailFailureNotify$: Observable<any> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrderActions.LOAD_ORDER_DETAILS_FAIL),
        map((action: any) => action.payload?.error),
        map(() => this.knBrCommonServive.setSpinner(false))
      ),
    { dispatch: false }
  );

  //@Effect({ dispatch: false })
  returnOrderNotify$: Observable<any> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrderActions.LOAD_ORDER_RETURN_REQUEST),
        map((action: any) => action.payload),
        map(() => this.knBrCommonServive.setSpinner(true))
      ),
    { dispatch: false }
  );

  // @Effect({ dispatch: false })
  returnOrderSucessNotify$: Observable<any> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrderActions.LOAD_ORDER_RETURN_REQUEST_SUCCESS),
        map((action: any) => action.payload),
        map(() => this.knBrCommonServive.setSpinner(false))
      ),
    { dispatch: false }
  );

  //@Effect({ dispatch: false })
  returnOrderFailureNotify$: Observable<any> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrderActions.LOAD_ORDER_RETURN_REQUEST_FAIL),
        map((action: any) => action.payload?.error),
        map(() => this.knBrCommonServive.setSpinner(false))
      ),
    { dispatch: false }
  );
  constructor(private actions$: Actions, private knBrCommonServive: KnBrCommonService) {}
}
